import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

const StyledFormContainer = styled(Column)`
  margin: auto;
  width: 100%;
  padding: ${getSpacing("4x", "3x")};
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("8x", 120)};
    max-width: 720px;
  }
`;

export const SignupFormContainer: React.FC<
  React.ComponentProps<typeof Column>
> = (props) => {
  return <StyledFormContainer {...props} />;
};
